import { chunk, concat, filter, has, orderBy } from 'lodash';
import React, { useMemo } from 'react';

import styled from '@emotion/styled';

import { PageWrapper } from '../styles';

import Card from '../components/card';
import Header from '../components/entries/header';
import Answer from '../components/result/answer';

import AnimatedBox from '../components/result/animated_box';
import AnswerBox from '../components/result/answer_box';
import CardsFadeIn from '../components/result/cards_fade_in';
import Grid from '../components/result/grid';
import Subtitle from '../components/result/subtitle';
import Title from '../components/result/title';

import QuestionBubble from '../components/vector/question_bubble';

function NewEntriesPage({ userEntries }) {
  console.log('NewEntriesPage', { userEntries });

  const userEntriesToShowLength = userEntries.length;
  const userEntriesSize = 'large';

  return (
    <PageWrapper>
      <Header />

      <Grid key="wrapper-grid">
        <AnswerBox key="answer-box" size={userEntriesSize}>
          <Title evenMargins>NEW ENTRIES</Title>
        </AnswerBox>

        <CardsFadeIn
          key="cards-fade-in"
          columns={userEntriesToShowLength}
          size={userEntriesSize}
        >
          {userEntries.map(userEntry => (
            <Card
              key={userEntry.user.id}
              title={`Rank ${userEntry.rank}`}
              user={userEntry.user}
              pointsPrefix=""
              points={userEntry.score / 100}
              pointsSuffix="CM"
              size={userEntriesSize}
            />
          ))}
        </CardsFadeIn>
      </Grid>
    </PageWrapper>
  );
}

export default NewEntriesPage;
